var React = require('react');

function Sort (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.93256 6C9.35648 6 9.58806 5.50557 9.31668 5.1799L5.3842 0.460929C5.1843 0.221052 4.81587 0.221052 4.61597 0.460929L0.683495 5.1799C0.412109 5.50557 0.643687 6 1.06761 6H8.93256Z","fill":"#9CA3AF","key":0}),React.createElement("path",{"d":"M8.9325 10C9.35642 10 9.588 10.4944 9.31661 10.8201L5.38413 15.5391C5.18424 15.7789 4.81581 15.7789 4.61591 15.5391L0.683434 10.8201C0.412048 10.4944 0.643626 10 1.06755 10H8.9325Z","fill":"#9CA3AF","key":1})]);
}

Sort.defaultProps = {"width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"};

module.exports = Sort;

Sort.default = Sort;
